module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAZklEQVQoU8WSwQ2AIBAEd+1KY1NQFtbgC4XEFzTE+jMmkMBL7z2bzO0dszO7MM0YGKJczM56kesAD0iBQ+AL+iGQNnsCXFqqUomVUnYmiO3WKNSBXgkfLp2c9egdUDoepZEXIUq8AV4mJCadQANnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/oldCode/title-icon.png
// module id = 170
// module chunks = 2